import React, { useState, useContext } from "react";
import {
  Box,
  Typography,
  Link,
  Container,
  IconButton,
  Divider,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AiFillHome } from "react-icons/ai";
import { styled } from "@material-ui/core/styles";
import Logo from "../assets/logoipsum.svg";
import { useHistory } from "react-router-dom";
import Login from "../views/pages/jobSeeker/Auth/Login";
import SignUp from "../views/pages/jobSeeker/Auth/SignUp";
import Forgot from "../views/pages/jobSeeker/Auth/Forgot";
import OTPFlow from "../views/pages/jobSeeker/Auth/OTPFlow";
import { useTranslation } from "react-i18next";

import { AuthContext } from "../context/Auth";
import { motion } from "framer-motion";
import ResetOTPFlow from "../views/pages/jobSeeker/Auth/ResetOTPFlow";
import ResetPassword from "../views/pages/jobSeeker/Auth/ResetPassword";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: "#fffff",
    color: "#fff",
    paddingTop: "40px",
    paddingLeft: "12.5%",
    paddingRight: "12%",
    "@media (max-width: 1610px)": {
      paddingLeft: "6%",
      paddingRight: "5%",
    },
    "@media (max-width: 1024px)": {
      paddingLeft: "5%",
      paddingRight: "5%",
    },
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
      gap: "16px",
    },
    "@media (max-width: 480px)": {
      flexWrap: "wrap",
      gap: "16px",
      paddingLeft: "5%",
      paddingRight: "5%",
    },
  },

  mainbox: {
    display: "flex",
    justifyContent: "center",
    gap: "75px",
    "@media (max-width: 1610px)": {
      gap: "58px",
    },
    "@media (max-width:1540px)": {
      gap: "40px",
    },
    "@media (max-width:1024px)": {
      display: "flex",
      justifyContent: "flex-start",
      gap: "10px",
    },
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
      gap: "16px",
    },
    "@media (max-width:480px)": {
      flexWrap: "wrap",
      gap: "0px",
      display: "flex",
      flexDirection: "column",
    },

    "& h6": {
      lineHeight: "20px",
    },
    "& h4": {
      fontWeight: "600",
    },
  },

  icons: {
    marginTop: "20px",
    display: "flex",
    gap: "10px",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
    },
  },

  column: {
    width: "130px",
    padding: theme.spacing(1),
    "@media (max-width: 1610px)": {
      width: "140px",
    },
    "@media (max-width: 768px)": {
      width: "105px",
    },
    "@media (max-width: 480px)": {
      width: "140px",
    },
    "@media (max-width: 390px)": {
      width: "120px",
    },
  },
  column1: {
    width: "230px",
    padding: theme.spacing(1),
    "@media (max-width: 1610px)": {
      width: "215px",
    },
    "@media (max-width: 480px)": {
      width: "180px",
    },
    "@media (max-width: 390px)": {
      width: "155px",
    },
  },
  column5: {
    width: "267px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      width: "65%",
    },
  },
  heading: {
    marginBottom: theme.spacing(3),
    color: "#000000",
    fontWeight: "600",
    whiteSpace: "nowrap",
    "@media (max-width: 480px)": {
      marginBottom: theme.spacing(2),
    },
  },
  link: {
    display: "block",
    marginBottom: theme.spacing(2),
    color: "black",
    textDecoration: "none",
    color: "#000000CC",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "14px",
    fontFamily: "Inter",
    textDecoration: "none !important",
    whiteSpace: "nowrap",
    "@media (max-width:1024px)": {
      fontSize: 12,
      lineHeight: "14px",
    },
  },

  logo: {
    height: 40,
    marginBottom: theme.spacing(2),
  },
  divider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "25px",

    "@media (max-width: 1610px)": {
      marginLeft: "8%",
      marginRight: "9%",
    },
    "@media (max-width: 1024px)": {
      marginLeft: "1%",
      marginRight: "1%",
    },
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
      gap: "16px",
    },
    "@media (max-width: 480px)": {
      paddingLeft: "5%",
      paddingRight: "5%",
    },
  },
  lowerbox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    "@media (max-width: 1610px)": {
      paddingLeft: "8%",
      paddingRight: "9%",
    },
    "@media (max-width: 1024px)": {
      paddingLeft: "1%",
      paddingRight: "1%",
    },
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
      gap: "16px",
    },
    "@media (max-width: 480px)": {
      paddingLeft: "5%",
      paddingRight: "5%",
    },
    [theme.breakpoints.down("sx")]: {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  lowerbox1: {
    display: "flex",
    gap: "22px",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      gap: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      gap: "20px",
    },
    [theme.breakpoints.down("xs")]: {
      marginTop: "10px",
      display: "flex",
      gap: "20px",
    },
  },
  link1: {
    color: "#000000CC",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "14px",
    fontFamily: "Inter",
    textDecoration: "none",
    margin: 0,
    "&:hover": {
      textDecoration: "none",
    },
  },
  logo: {
    height: "60px",
    width: "60px",
    border: "1px solid #5E58E4",
    borderRadius: "50px",
    background:
      "radial-gradient(50% 50% at 50% 50%,  #5E58E4 50%, #5E58E4 100%)",
    color: "white",
    marginRight: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  imageBox: {
    marginBottom: "16px",
  },
  imageStyle: {
    "@media (max-width: 1024px)": {
      width: "100%",
    },
    "@media (max-width: 768px)": {
      width: "100%",
    },
    "@media (max-width: 480px)": {
      width: "100%",
    },
  },
}));

const RecruiterFooter = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const history = useHistory();
  const { isLogin } = useContext(AuthContext);
  const [open, setOpen] = React.useState(false);
  const [opensignup, setOpenSignup] = React.useState(false);
  const [openForgot, setOpenForgot] = React.useState(false);
  const [openOTP, setOpenOTP] = React.useState(false);
  const [openSuccess, setOpenSuccess] = React.useState(false);
  const { t } = useTranslation();

  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const fadeInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const fadeInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const handleOpen = () => {
    setOpenSignup(false);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const handleSignupOpen = () => {
    setOpenSignup(true);
    setOpen(false);
  };

  const handleSignupClose = () => setOpenSignup(false);

  const handleForgotOpen = () => {
    setOpenForgot(true);
    setOpen(false);
  };

  const handleForgotClose = () => setOpenForgot(false);

  const handleOTPOpen = () => {
    setOpenOTP(true);
    setOpenForgot(false);
  };

  const handleOTPClose = () => setOpenOTP(false);

  const handScuccessClick = () => {
    setOpenOTP(false);
    setOpenSuccess(true);
  };

  const handleSuccessClose = () => setOpenSuccess(false);

  const handleCardClick = (index) => {
    handleSignupOpen();
  };

  const [openReset, setOpenReset] = React.useState(false);

  const handleResetOpen = () => {
    setOpenReset(true);
    setOpenResetOTP(false);
  };

  const handleResetClose = () => setOpenReset(false);
  const [openResetOTP, setOpenResetOTP] = React.useState(false);
  const handleResetOTPOpen = () => {
    setOpenResetOTP(true);
    setOpenForgot(false);
  };

  const handleResetOTPClose = () => setOpenResetOTP(false);

  return (
    <>
      <Box className={classes.footer}>
        <Box className={classes.mainbox}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
          >
            <Box className={classes.column1}>
              <Box className={classes.imageBox}>
                <img src={Logo} alt="logo" className={classes.imageStyle} />
              </Box>
              <Typography variant="h6">{t("footer.description")}</Typography>

              <Box className={classes.icons}>
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="./images/facebook.png"
                    alt="Facebook"
                    height={20}
                    width={20}
                  />
                </a>
                <a
                  href="https://www.twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="./images/twitter.png"
                    alt="Twitter"
                    height={20}
                    width={20}
                  />
                </a>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="./images/linkedin.png"
                    alt="LinkedIn"
                    height={20}
                    width={20}
                  />
                </a>
              </Box>
            </Box>
          </motion.div>
          <Box className={classes.column}>
            <Typography variant="h4" className={classes.heading}>
              {t("footer.forRecruiters")}
            </Typography>
            <Link href="/contact-us" className={classes.link}>
              {t("footer.contactUs")}
            </Link>
            <Link href="/pricing" className={classes.link}>
              {t("footer.pricing")}
            </Link>
          </Box>

          <Box className={classes.column}>
            <Typography variant="h4" className={classes.heading}>
              {t("footer.aboutUs")}
            </Typography>
            <Link href="/recruiter-blogs" className={classes.link}>
              {t("footer.blog")}
            </Link>
          </Box>
          <Box className={classes.column}>
            <Typography variant="h4" className={classes.heading}>
              {t("footer.support")}
            </Typography>
            <Link href="/faqs" className={classes.link}>
              {t("footer.faqs")}
            </Link>
            <Link
              href="/privacyPolicy"
              className={classes.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.privacyPolicy")}
            </Link>

            <Link
              href="/termsandcondition"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              {t("footer.termsConditions")}
            </Link>
          </Box>

          <Box className={classes.column5}>
            <Typography variant="h4" className={classes.heading}>
              {t("footer.downloadApp")}
            </Typography>
            <Typography variant="h6">{t("footer.appDescription")}</Typography>
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
            >
              <Box
                mt={2}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                }}
              >
                <a
                  href="https://www.apple.com/app-store/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="images/applestore.png"
                    alt="Apple Store"
                    height="40px"
                    style={{ objectFit: "contain" }}
                  />
                </a>

                <a
                  href="https://store.google.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="images/googlestore.png"
                    alt="Google Store"
                    height="40px"
                    style={{ objectFit: "contain" }}
                  />
                </a>
              </Box>
            </motion.div>
          </Box>
        </Box>

        <Divider className={classes.divider}></Divider>
        <Box mt={3} mb={2} className={classes.lowerbox}>
          <Box>
            <Typography variant="h6">{t("footer.copyright")}</Typography>
          </Box>
          <Box className={classes.lowerbox1}>
            <Link
              href="/privacyPolicy"
              className={classes.link1}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("footer.privacyPolicy")}
            </Link>

            <Link
              href="/termsandcondition"
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link1}
            >
              {t("footer.termsConditions")}
            </Link>
          </Box>
        </Box>
      </Box>
      <Login
        open={open}
        onClose={handleClose}
        handleSignUpClick={handleSignupOpen}
        handleForgotClick={handleForgotOpen}
        handletestClick={handleOTPOpen}
        setEmail={setEmail}
      />
      <SignUp
        open={opensignup}
        onClose={handleSignupClose}
        handleLoginClick={handleOpen}
        handletestClick={handleOTPOpen}
        setEmail={setEmail}
      />

      <Forgot
        open={openForgot}
        onClose={handleForgotClose}
        handleForgotClick={handleForgotOpen}
        handletestClick={handleOTPOpen}
        setEmail={setEmail}
      />

      <OTPFlow
        open={openOTP}
        onClose={handleOTPClose}
        handScuccessClick={handScuccessClick}
        email={email}
      />
      <ResetOTPFlow
        open={openResetOTP}
        onClose={handleResetOTPClose}
        handleResetClick={handleResetOpen}
        email={email}
      />

      <ResetPassword
        open={openReset}
        onClose={handleResetClose}
        handScuccessClick={handScuccessClick}
        email={email}
      />
    </>
  );
};

export default RecruiterFooter;
